// Müşteri Kabul ve Bilgi Kartı - alan yapılandırması (PDF'e göre)

export const MUSTERI_TURLERI = ["Şahıs", "Ltd.", "A.Ş.", "Adi Ort.", "Koop.", "Diğer"];

export const RISK_SORULARI = [
  { key: "risk_faaliyet_gercek", label: "Faaliyetin ve işyerinin gerçekliği teyit edildi mi?" },
  { key: "risk_ortak_dogrulama", label: "Ortak / yönetici / yetkili bilgileri doğrulandı mı?" },
  { key: "risk_hacim_uyum", label: "Faaliyet hacmi ile beyan edilen iş modeli uyumlu mu?" },
  { key: "risk_nakit", label: "Olağandışı yoğun nakit hareketi bulunuyor mu?" },
  { key: "risk_belge_duzen", label: "Belge düzeni ve alış-satış zincirinde risk göstergesi var mı?" },
  { key: "risk_gecmis_uyumsuz", label: "Geçmiş dönem vergi / SGK uyumsuzluğu bulunuyor mu?" },
  { key: "risk_inceleme", label: "Devam eden vergi incelemesi / izaha davet süreci var mı?" },
  { key: "risk_devir_sorun", label: "Önceki mali müşavirden devir konusunda sorun bulunuyor mu?" },
  { key: "risk_isteksiz", label: "Müşteri bilgi ve belge vermede isteksiz / gecikmeli mi?" },
];

// Devir kontrol checklist maddeleri
export const DEVIR_KONTROL = [
  { key: "devir_defter_teslim", label: "Defter ve belgeler teslim alındı" },
  { key: "devir_edefter_berat", label: "E-Defter beratları kontrol edildi" },
  { key: "devir_kasa_banka", label: "Kasa ve banka bakiyeleri kontrol edildi" },
  { key: "devir_stok", label: "Stok listesi alındı" },
  { key: "devir_amortisman", label: "Amortisman kayıtları kontrol edildi" },
  { key: "devir_dava", label: "Devam eden dava / inceleme soruldu" },
  { key: "devir_son_beyan", label: "Son dönem beyannameleri kontrol edildi" },
  { key: "devir_acilis_mizan", label: "Açılış / devir mizanı alındı" },
  { key: "devir_cari", label: "Cari hesaplar kontrol edildi" },
  { key: "devir_sabit_kiymet", label: "Sabit kıymet listesi alındı" },
  { key: "devir_borc_sorgu", label: "Vergi / SGK borçları sorgulandı" },
  { key: "devir_eksik_bildirim", label: "Geçmiş dönem eksik bildirimleri soruldu" },
];

export const BELGE_TIPLERI = [
  "Vergi Levhası", "Kimlik Fotokopisi", "İmza Sirküleri", "Ticaret Sicil Gazetesi",
  "Faaliyet Belgesi", "Vekaletname", "Sözleşme", "Kira Kontratı", "Devir Teslim Tutanağı",
  "Mizan / Açılış Bilgileri", "Nüfus Cüzdanı", "İkametgah", "Diğer",
];

// Sekmeli form yapısı: her sekme accordion bölümlerini içerir
export const FORM_SECTIONS = [
  {
    id: "A", title: "A. Mükellef / Firma Temel Bilgileri",
    fields: [
      { key: "musteri_kodu", label: "Müşteri Kodu", type: "text" },
      { key: "unvan", label: "Ad Soyad / Ticaret Unvanı", type: "text", required: true, span: 2 },
      { key: "tur", label: "Şirket / Mükellef Türü", type: "select", options: MUSTERI_TURLERI, required: true },
      { key: "tc_vergi_no", label: "T.C. / Vergi Kimlik No", type: "text" },
      { key: "vergi_dairesi", label: "Vergi Dairesi", type: "text" },
      { key: "ticaret_sicil_no", label: "Ticaret Sicil No", type: "text" },
      { key: "mersis_no", label: "MERSİS No", type: "text" },
      { key: "nace_kodu", label: "NACE Kodu", type: "text" },
      { key: "faaliyet_konusu", label: "Faaliyet Konusu", type: "text", span: 2 },
      { key: "merkez_adresi", label: "Merkez Adresi", type: "textarea", span: 3 },
      { key: "ana_faaliyet_yeri", label: "Ana Faaliyet Yeri", type: "text" },
      { key: "sube_ek_isyeri", label: "Şube / Ek İşyeri", type: "text" },
      { key: "kabul_devir_tarihi", label: "Kabul / Devir Tarihi", type: "date" },
      { key: "kurulus_ise_baslama", label: "Kuruluş / İşe Başlama", type: "date" },
    ],
  },
  {
    id: "B", title: "B. Yetkili ve İletişim Bilgileri",
    fields: [
      { key: "firma_yetkilisi", label: "Firma Yetkilisi", type: "text" },
      { key: "evrak_sorumlusu", label: "Evrak Sorumlusu", type: "text" },
      { key: "muhasebe_irtibat", label: "Muhasebe İrtibat Kişisi", type: "text" },
      { key: "cep_telefonu", label: "Cep Telefonu", type: "text" },
      { key: "email", label: "E-posta", type: "text" },
      { key: "tercih_iletisim", label: "Tercih Edilen İletişim", type: "multi", options: ["Telefon", "WhatsApp", "E-posta"] },
      { key: "evrak_teslim_gunu", label: "Evrak Teslim Günü", type: "text" },
      { key: "tahsilat_odeme_gunu", label: "Tahsilat / Ödeme Günü (Ayın)", type: "number" },
    ],
  },
  {
    id: "C", title: "C. Vergisel Yükümlülükler ve E-Uygulamalar",
    fields: [
      { key: "vy_kdv", label: "KDV", type: "bool" },
      { key: "vy_gelir", label: "Gelir Vergisi", type: "bool" },
      { key: "vy_kurumlar", label: "Kurumlar Vergisi", type: "bool" },
      { key: "vy_gecici", label: "Geçici Vergi", type: "bool" },
      { key: "vy_muhtasar", label: "Muhtasar ve Prim Hizmet", type: "bool" },
      { key: "vy_damga", label: "Damga Vergisi", type: "bool" },
      { key: "vy_efatura", label: "E-Fatura", type: "bool" },
      { key: "vy_earsiv", label: "E-Arşiv Fatura", type: "bool" },
      { key: "vy_edefter", label: "E-Defter", type: "bool" },
      { key: "vy_eirsaliye", label: "E-İrsaliye", type: "bool" },
      { key: "vy_defterbeyan", label: "Defter-Beyan Sistemi", type: "bool" },
      { key: "vy_okc", label: "ÖKC / Yazar Kasa", type: "bool" },
      { key: "vy_pos", label: "POS / Sanal POS", type: "bool" },
      { key: "vy_etebligat", label: "E-Tebligat", type: "bool" },
      { key: "vy_kep", label: "KEP", type: "bool" },
      { key: "ozel_entegrator", label: "Özel Entegratör", type: "text" },
      { key: "beyan_donemleri", label: "Beyan Dönemleri / Özel Durumlar", type: "text", span: 2 },
      { key: "vergi_borcu", label: "Mevcut Vergi Borcu", type: "varyok" },
      { key: "yapilandirma", label: "Yapılandırma / Taksit", type: "varyok" },
      { key: "inceleme_izaha", label: "İnceleme / İzaha Davet", type: "varyok" },
      { key: "ozel_esas_risk", label: "Özel Esas / Risk Kaydı", type: "varyok" },
    ],
  },
  {
    id: "D", title: "D. SGK ve Personel Bilgileri",
    fields: [
      { key: "sgk_sicil_no", label: "SGK İşyeri Sicil No", type: "text" },
      { key: "calisan_sayisi", label: "Çalışan Sayısı", type: "number" },
      { key: "bordro_sorumlusu", label: "Bordro Sorumlusu", type: "text" },
      { key: "tesvik", label: "Teşvik Durumu", type: "varyok" },
      { key: "personel_ozellikleri", label: "Personel Özellikleri", type: "multi", options: ["Emekli", "Yabancı", "Stajyer/Çırak", "Alt İşveren / Şube"], span: 3 },
    ],
  },
  {
    id: "E", title: "E. Muhasebe Devir ve Açılış Kontrolü",
    fields: [
      { key: "onceki_musavir", label: "Önceki Mali Müşavir", type: "text" },
      { key: "ayrilma_nedeni", label: "Ayrılma Nedeni", type: "text" },
      { key: "devir_gorusmesi", label: "Devir Görüşmesi", type: "select", options: ["Yapıldı", "Yapılmadı"] },
      { key: "devir_tutanagi", label: "Devir Teslim Tutanağı", type: "select", options: ["Var", "Yok"] },
    ],
    checklist: DEVIR_KONTROL,
  },
  {
    id: "F", title: "F. Dijital Erişim, Yetki ve Araçlar",
    fields: [
      { key: "de_interaktif_vd", label: "İnteraktif Vergi Dairesi", type: "bool" },
      { key: "de_ebeyanname", label: "E-Beyanname", type: "bool" },
      { key: "de_eimza", label: "E-İmza", type: "bool" },
      { key: "de_defterbeyan", label: "Defter-Beyan", type: "bool" },
      { key: "de_sgk_ebildirge", label: "SGK e-Bildirge", type: "bool" },
      { key: "de_efatura_earsiv", label: "E-Fatura / E-Arşiv", type: "bool" },
      { key: "de_banka", label: "Banka Entegrasyonu", type: "bool" },
      { key: "de_edefter", label: "E-Defter", type: "bool" },
      { key: "de_turmob", label: "TÜRMOB / Meslek Yazılımı", type: "bool" },
      { key: "de_kep", label: "KEP", type: "bool" },
      { key: "de_mali_muhur", label: "Mali Mühür", type: "bool" },
      { key: "de_diger", label: "Diğer", type: "text", span: 2 },
    ],
  },
  {
    id: "G", title: "G. Müşteri Kabul Risk Değerlendirmesi",
    risk: true,
  },
  {
    id: "H", title: "H. Ofis İçi Kabul Kararı ve Takip",
    fields: [
      { key: "kabul_sonucu", label: "Kabul Sonucu", type: "select", options: ["Uygun", "Şartlı Kabul", "İlave İnceleme", "Kabul Edilmedi"] },
      { key: "risk_seviyesi", label: "Risk Seviyesi", type: "select", options: ["Düşük", "Orta", "Yüksek"] },
      { key: "aylik_hizmet_ucreti", label: "Aylık Hizmet Ücreti (₺)", type: "number" },
      { key: "sorumlu_personel", label: "Sorumlu Personel", type: "text" },
      { key: "sozlesme_tarihi", label: "Sözleşme Tarihi", type: "date" },
      { key: "kontrol_sorumlusu", label: "Kontrol Sorumlusu", type: "text" },
      { key: "tamamlama_tarihi", label: "Tamamlama Tarihi", type: "date" },
      { key: "ozel_sart_eksik_evrak", label: "Özel Şart / Eksik Evrak", type: "textarea", span: 3 },
      { key: "genel_notlar", label: "Genel Notlar / Özel Açıklamalar", type: "textarea", span: 3 },
    ],
  },
];
